import React from "react";
import PageContainer from "../custom/Page";
import HeaderWithHelpDialog from "./components/Reports/Contract/byHierarchy/HeaderWithHelpDialog";
import ContractsByHierarchyContext from "./components/Reports/Contract/byHierarchy/ContractsByHierarchyContext";

import { CUSTOMER_ROUTES, HierarchyViewTypeEnum } from "../util";

const params = { hierarchyViewType: HierarchyViewTypeEnum.DIRECTLY };

const ReportContractByCustomer = () => (
  <PageContainer full>
    <HeaderWithHelpDialog />
    <ContractsByHierarchyContext
      enableUserSelect
      params={params}
      hierarchyViewType={HierarchyViewTypeEnum.DIRECTLY}
      customerRoutePrefix={CUSTOMER_ROUTES.AGENT}
    />
  </PageContainer>
);

export default ReportContractByCustomer;
